/*
 * Module for the PROP Distribution Election step of the PROP Deferral and Distribution form
*/
rs.module("ui/content/communications/onlineforms/propdistributionelection",

    [
        "common/select-helper",
        "controls/components/event-banner",
        "common/visibility"
    ],

    function (selectHelper, eventBanner, visibility) {
        // Initialize the module
        function initialize(jsSelectors) {

            var stepContainer = $.js(jsSelectors.stepContainer);
            var distributionElectionRadio = stepContainer.js(jsSelectors.distributionElectionRadio, { multiple: true });
            var distributionElectionDescriptionDiv = stepContainer.js(jsSelectors.distributionElectionDescriptionDiv, { multiple: true });
            var partialPaymentAmount = stepContainer.js(jsSelectors.partialPaymentAmount, { required: false });

            var selected = distributionElectionRadio.filter(":checked");
            var selectedIndex = distributionElectionRadio.index(selected);
            if (selectedIndex !== null && selectedIndex >= 0) {
                showSelectedPROPDistributionElectionDescription(selectedIndex);
            }

            // Handle the distributionElectionRadio click event
            distributionElectionRadio.on("click", function () {

                // Clear partial payment amount and errors
                partialPaymentAmount.val('');
                partialPaymentAmount.clearErrors();

                var selectedIndex = distributionElectionRadio.index(this);
                showSelectedPROPDistributionElectionDescription(selectedIndex);
            });

            // Show (slide down) the description for the selected prop distribution election
            function showSelectedPROPDistributionElectionDescription(selectedIndex) {

                // Close all quickly
                distributionElectionDescriptionDiv.stop(true, true).slideUp(150);

                // Open the selected one
                distributionElectionDescriptionDiv.eq(selectedIndex).stop(true, true).slideDown(150);
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);